import { AppBar, Button, Toolbar, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { LinkType } from '../../constans';
import { getLinks } from '../../helpers';

export const StyledAppBar = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  return (
    <AppBar sx={{ backgroundColor: 'transparent', boxShadow: 'none', maxHeight: '2vh' }} position="relative">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box display="flex">
          <img src="/icons/mluviiLogo.svg" alt="Mluvii logo" style={{ width: '6rem', marginRight: '1rem' }} />
          <Box
            sx={{
              display: { lg: 'flex', md: 'flex', xs: 'none', sm: 'none' },
              justifyContent: 'start',
              alignItems: 'start'
            }}
          >
            <Button component="a" href={getLinks(LinkType.howTo, language)}>{t('header.howTo')}</Button>
            <Button component="a" href={getLinks(LinkType.functions, language)}>{t('header.functions')}</Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: { lg: 'flex', md: 'flex', xs: 'none', sm: 'flex' },
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography mr="2rem" variant="body2">
            {t('header.alreadyRegistred')}
          </Typography>
          <Button
            component="a"
            href={getLinks(LinkType.logIn, language)}
            size="medium"
            color="success"
            variant="outlined"
          >
            {t('header.logIn')}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
